import carte from "../../images/carte-interactive.jpg";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import img from "../../images/reservoire (1).png";
import pplImg from "../../images/leg-1.jpg";
import waterImg from "../../images/leg-4.jpg";
import robineImg from "../../images/robiné.jpg";
import nowaterImg from "../../images/no-water.jpg";
import roueImg from "../../images/chavenay-carte.jpg";
import reservoir2 from "../../images/reservoire2.png";
import port from "../../images/port.jpg";
import castle from "../../images/castle.jpg";
import baily from "../../images/bailly.jpg";
import rennemoulin from "../../images/rennemoulin.jpg";
import saint_cyr_carte from "../../images/saint-cyr-carte.jpg";
import chesnay from "../../images/le-chesnay-carte.jpg";

const InteractiveCarte = () => {
  return (
    <div className="container mt-20 mb-20">
      <h1 className="text-3xl font-bold text-center uppercase text-primary">
        CARTE INTERACTIVE
      </h1>
      <div className="flex flex-col justify-center mt-10 space-x-9 md:flex-row">
        <div className="mt-11">
          <div className="font-bold text-center">LÉGENDE</div>
        </div>

        <div className="flex flex-col ">
          <div className="flex justify-center">
            <img src={pplImg} alt="" />{" "}
          </div>
          <div className="text-center">HABITANTS</div>
        </div>

        <div className="flex flex-col ">
          <div className="flex justify-center">
            <img src={robineImg} alt="" />{" "}
          </div>
          <div className="text-center">EAU POTABLE </div>
        </div>
      </div>
      <div className="container flex justify-center mt-20">
        <div className="relative">
          <div
            className={`absolute top-[50px] md:top-[130px] left-1 md:left-11 lg:top-[215px] lg:left-20 cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Beynes
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Confluence entre Mauldre et Gally
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        7 567
                      </p>
                    </div>
               
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[110px] lg:left-44 cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Crespières
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        1 567
                      </p>
                    </div>
                    
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[234.4375px] lg:left-[180px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Thiverval-Grignon
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        1 100
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                  
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[166.4375px] lg:left-[260px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Davron
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        311
                      </p>
                    </div>

                   
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[624.4375px] lg:left-[158px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Coignières
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Réservoir
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        4332
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[365.4375px] lg:left-[270px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Plaisir
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        31753
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[500.4375px] lg:left-[290px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Elancourt
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        25958
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

              
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[575.4375px] lg:left-[250px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Maurepas
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        18769
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[607.4375px] lg:left-[270px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  La Verrière
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        5995
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                  
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[136.4375px] lg:left-[340px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Feucherolles
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        2839
                      </p>
                    </div>

                  
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[210.4375px] lg:left-[375px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Chavenay
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={roueImg} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Le moulin de Mezu
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        1836
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[335.4375px] lg:left-[320px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Les Clayes-sous-Bois
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        17668
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                  
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[308.4375px] lg:left-[422px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Villepreux
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Pont sur le ru de Gally @DR
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        10024
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[295.4375px] lg:left-[500px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Rennemoulin
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={rennemoulin} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Le ru de Gally à Rennemoulin @DR
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        222
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[275.4375px] lg:left-[600px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Bailly
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={baily} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Usine de traitement des eaux usées Carré de Réunion @LWA
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        3866
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                 

                   
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[255.4375px] lg:left-[570px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Noisy-le-Roi
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        3213
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

               
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[193.4375px] lg:left-[440px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Saint-Nom-la-Bretèche
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        4972
                      </p>
                    </div>

                
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[190.4375px] lg:left-[645px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Louveciennes
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={port} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Usine de production d’eau potable @Antoine Pasquier
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        7059
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                  
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[175.4375px] lg:left-[755px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Bougival
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={castle} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Ce bâtiment abritait la machine alimentant les bassins de
                      Versailles et de Marly @Moonik
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        8848
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[230.4375px] lg:left-[705px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  La Celle Saint-Cloud
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        21275
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                    
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[260.4375px] lg:left-[810px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Vaucresson
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        8747
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[300.4375px] lg:left-[630px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Le Chesnay-Rocquencourt
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={chesnay} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        31324
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

            
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[310.4375px] lg:left-[820px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Marnes-la-Coquette
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        1712
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[338.4375px] lg:left-[855px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Ville d'Avray
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        11419
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[400.4375px] lg:left-[920px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Chaville
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        19619
                      </p>
                    </div>

                  
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[430.4375px] lg:left-[855px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Viroflay
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        15472
                      </p>
                    </div>

               
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[475.4375px] lg:left-[855px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Vélizy-Villacoublay
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        21090
                      </p>
                    </div>

                 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[345.4375px] lg:left-[970px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Sèvres
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        23206
                      </p>
                    </div>

              
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[245.4375px] lg:left-[880px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Garches
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        17662
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[230.4375px] lg:left-[920px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Saint-Cloud
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        29360
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[386.4375px] lg:left-[445px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Fontenay-le-Fleury
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        13222
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

                   

               
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[405.4375px] lg:left-[440px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Bois d'Arcy
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={reservoir2} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Réservoir @DR
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        14081
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

            
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[405.4375px] lg:left-[540px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Saint-Cyr-l'Ecole
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={saint_cyr_carte} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Usine de traitement des eaux usées Carré de Réunion @LWA
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        18344
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

              
 
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[425.4375px] lg:left-[740px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Versailles
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                    <p className="p-2 font-bold text-center text-white bg-primary">
                      Réservoirs de Satory @DR
                    </p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        85461
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

             
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[524.4375px] lg:left-[415px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Trappes
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        31854
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

               
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[540.4375px] lg:left-[465px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Montigny-le-Bretonneux
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        33252
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

              
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[540.4375px] lg:left-[730px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Buc
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        5560
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[635.4375px] lg:left-[700px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Toussus-le-Noble
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        1166
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[565.4375px] lg:left-[610px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Guyancourt
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        27328
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

            
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[585.4375px] lg:left-[410px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Voisins-le-Bretonneux
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        11358
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>

             
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[660.4375px] lg:left-[490px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Magny-les-Hameaux
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        9136
                      </p>
                    </div>

                
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div
            className={`absolute top-[25px] md:top-[80px] left-5 md:left-28 lg:top-[680.4375px] lg:left-[580px] cursor-pointer`}
          >
            <Popover>
              <PopoverTrigger asChild>
                <div className="text-transparent hover:p-1 hover:text-white hover:bg-primary hover:-translate-x-3 hover:text-xl">
                  Châteaufort
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-52 md:w-full">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <img src={img} alt="" className="w-full" />
                  </div>
                  <div className="space-y-2">
                    <div className="flex space-x-5">
                      <img src={pplImg} alt="" />
                      <p className="flex items-center font-bold text-center">
                        1375
                      </p>
                    </div>

                    <div className="flex space-x-5">
                      <img src={robineImg} alt="" />
                      <div className="flex-col items-center ">
                        <div className="font-bold">AQUAVESC</div>
                        <div>PRODUCTION | DISTRIBUTION</div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <div className="overflow-auto">
            <img src={carte} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveCarte;
